class CustomShapesComponent extends HTMLElement {

  constructor() {
    super();
    this.shapeType = 'custom-shape'
    
    document.addEventListener('custom-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }

  onShapeCategorySelected() {
    this.onShapeFileClick(this.shapeType)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  onShapeFileClick(id) {
    this.shapeType = id
    switch(id) {
      case 'custom-shape':
        loadCustomShapesInputTable()
        break
      case 'custom-aluminum-stringer-shapes':
        loadCustomAluminumShapesTable()
        break
      case 'custom-soldier-shapes':
        loadCustomSoldierShapesTable()
        break
    }  
    
    this.resetButton('custom-shape')
    this.resetButton('custom-aluminum-stringer-shapes')
    this.resetButton('custom-soldier-shapes')
    document.getElementById(id).classList.add('btn-primary')
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div>
      <button class="btn btn-default button-shadow" id='custom-shape'>User Defined</button>
      <button class="btn btn-default button-shadow" id='custom-aluminum-stringer-shapes'>Custom Aluminum</button>
      <button class="btn btn-default button-shadow" id='custom-soldier-shapes'>Custom Steel Soldier</button>
    </div>

    <h4 id="use-custom-shape-checkbox" class='text-left'>
      <label class="checkbox-inline" id="use-custom-shape-label">
        <input type="checkbox" id="use-custom-shape" onclick="onUseCustomShapeClick();">
        Use this shape
      </label>
    </h4>
    `

    document.getElementById('custom-shape').onclick = (() => this.onShapeFileClick('custom-shape'))
    document.getElementById('custom-aluminum-stringer-shapes').onclick = (() => this.onShapeFileClick('custom-aluminum-stringer-shapes'))
    document.getElementById('custom-soldier-shapes').onclick = (() => this.onShapeFileClick('custom-soldier-shapes'))
  }
}

customElements.define('custom-shape-selector-component', CustomShapesComponent)

